module.exports = __webpack_public_path__ + "static/media/all-events.df60a3be.svg";